import { useState, type ReactElement, type ReactNode } from 'react';
import { Icon, type IconName } from '../Icon/Icon';
import styles from './Thumbnail.module.scss';

export interface ThumbnailProps {
  src: string | null;
  alt: string;
  fallbackIcon?: IconName;
  fallbackLabel?: string;
  /** Метка в углу (номер в посте, «видео»). */
  corner?: ReactNode;
  square?: boolean;
}

/** Превью медиа; нет картинки или не загрузилась — иконка с подписью. */
export function Thumbnail({ src, alt, fallbackIcon = 'image', fallbackLabel, corner, square }: ThumbnailProps): ReactElement {
  const [failed, setFailed] = useState(false);
  return (
    <div className={`${styles.thumb} ${square ? styles.square : ''}`}>
      {src && !failed ? (
        <img src={src} alt={alt} loading="lazy" onError={() => setFailed(true)} />
      ) : (
        <span className={styles.fallback}>
          <Icon name={fallbackIcon} size={28} title={alt} />
          {fallbackLabel}
        </span>
      )}
      {corner ? <span className={styles.corner}>{corner}</span> : null}
    </div>
  );
}
